import { AxiosError } from "axios";
import toast from "react-hot-toast";

const showMutationError =
  (fallbackMessage = "An error occurred") =>
  (error: unknown) => {
    const msg =
      !navigator.onLine ? "Looks like you are offline" : error instanceof AxiosError
        ? (error.response?.data?.message ?? fallbackMessage)
        : fallbackMessage;

    toast.error(msg);
  };

export default showMutationError;